"use client";

import { useParams } from "next/navigation";
import { ApiNews } from "@/api/news";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useDetailNewsData = () => {
  const params = useParams();
  const { id } = params;
  const isIdValid = typeof id === "string" && !Number.isNaN(+id);

  const { data: detailNews, isLoading: detailNewsLoading } = useLocalizedQuery({
    queryKey: ["detailNews", +id!],
    queryFn: async lang => ApiNews.getDetailNews(lang, +id!),
    options: { enabled: isIdValid },
  });

  return { detailNews, detailNewsLoading };
};
